import { useState, useCallback } from "react";

// Card/list view preference persisted per page in localStorage.
// `pageKey` scopes the stored value so each listing page remembers its own choice.
export default function useViewMode(pageKey, defaultMode = "list") {
  const storageKey = `view_mode_${pageKey}`;

  const [viewMode, setViewModeState] = useState(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored === "card" || stored === "list" ? stored : defaultMode;
    } catch {
      return defaultMode;
    }
  });

  const setViewMode = useCallback(
    (mode) => {
      setViewModeState(mode);
      try {
        localStorage.setItem(storageKey, mode);
      } catch {
        // storage unavailable (private mode / quota) — keep in-memory state only
      }
    },
    [storageKey]
  );

  return [viewMode, setViewMode];
}
